<div class="position-relative w-100 padding">
  <div class="container position-relative w-100 h-100">
    <div class="col-12 d-flex justify-content-center mt-20px">
      <app-template-slot [topBig]="'div-gpt-ad-1606730682358-0'"
                         [topSmall]="'div-gpt-ad-1606805762044-0'">
      </app-template-slot>
    </div>
    <div class="row d-flex justify-content-center">
      <div class="col max-width-text">
        <h1 class="h1 mt-40px mb-20px text-center pb-0">โปรแกรม คำนวณภาษีหัก ณ ที่จ่าย และ ภาษีมูลค่าเพิ่ม (VAT)</h1>
        <p class="p1 text-center text-gray-medium pb-0">กรอกราคาก่อน VAT หรือ ราคารวม VAT หรือ ยอดที่ต้องโอนหลังหักภาษี
          ณ ที่จ่าย
          แล้วแต่กรณี เพื่อให้โปรแกรม iTAX คำนวณตัวเลขได้อย่างถูกต้อง</p>
        <div class="w-100 position-relative float-left mt-20px mb-30px">
          <app-calculate-box (finishedCalChange)="onCalChange($event)"></app-calculate-box>
        </div>
        <div class="w-100 position-relative float-left mb-30px">
          <h2 class="h2 text-center mb-10px">โปรแกรมนี้ช่วยให้คุณ :</h2>
          <ul class="wrap-list">
            <li>รู้ว่า หัก ณ ที่จ่าย 3% แล้วต้องโอนกี่บาท</li>
            <li>คำนวณราคารวม VAT</li>
            <li>รู้ยอดโอนหลังหักภาษี ณ ที่จ่าย</li>
          </ul>
        </div>
        <div class="col-12 d-flex justify-content-center mb-30px">
          <app-template-slot [mode]="googleAds.Ads300"
                             [bottom]="'div-gpt-ad-1606808310162-0'">
          </app-template-slot>
        </div>
        <h2 class="h2 font-weight-bold text-center pb-10px">ตัวอย่างอัตราภาษีหัก ณ ที่จ่าย</h2>
        <div class="w-100 position-relative float-left mb-30px">
          <app-example-tax></app-example-tax>
        </div>
      </div>
    </div>
    <div class="w-100 mb-30px">
      <app-tax-detail></app-tax-detail>
    </div>
  </div>
</div>
